import { render, staticRenderFns } from "./PgDetail.vue?vue&type=template&id=f0640b86&"
import script from "./PgDetail.vue?vue&type=script&lang=js&"
export * from "./PgDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PgDetail.vue"
export default component.exports